import { gql, QueryHookOptions, useQuery } from "@apollo/client";

import type { BusinessAssetsByEmailPayload } from "../schema.generated";

export interface BusinessAssetsQueryVariables {
  email: string;
  year?: number | null;
}

export interface BusinessAssetsQueryResult {
  businessAssets: BusinessAssetsByEmailPayload;
}

export const BUSINESS_ASSETS_QUERY = gql`
  query businessAssets($email: String!, $year: Int) {
    businessAssets(email: $email, year: $year) {
      assets {
        id
        assetClass
        assetType
        vehicleType
        note
        amount
        purchaseDate
        depreciationPeriodYears
        receipts {
          id
          filetype
          fullsize
        }
        depreciations {
          year
          startAmount
          depreciationAmount
          depreciationMonths
        }
        naturallyDepreciated
        categoryCode
        endAmount
        exitReason
        exitAmount
        exitDate
        isExitedWithVat
        bookValueOnExit
        cumulativeDepreciationAmount
        metaData {
          amount
          transactionName
          transactionValutaDate
          transactionDescription
        }
      }
      sums {
        assetType
        totalAmount
        totalStartAmount
        totalAdditionsAmount
        totalDepreciationAmount
        totalCumulativeDepreciationAmount
        totalDisposalsAmount
        totalEndAmount
      }
    }
  }
`;

export const useBusinessAssetsQuery = (
  options?: QueryHookOptions<
    BusinessAssetsQueryResult,
    BusinessAssetsQueryVariables
  >
) =>
  useQuery<BusinessAssetsQueryResult, BusinessAssetsQueryVariables>(
    BUSINESS_ASSETS_QUERY,
    options
  );
